export default "__VITE_ASSET__be126e41__"